import { render } from "./MyRating.vue?vue&type=template&id=d3cfb4b0&scoped=true"
import script from "./MyRating.vue?vue&type=script&lang=js"
export * from "./MyRating.vue?vue&type=script&lang=js"

import "./MyRating.vue?vue&type=style&index=0&id=d3cfb4b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3cfb4b0"]])

export default __exports__